import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--navy)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background texture */}
      <div style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: 'radial-gradient(circle at 20% 80%, rgba(237,28,36,0.10) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(237,28,36,0.06) 0%, transparent 50%)',
        pointerEvents: 'none'
      }} />

      <div style={{ width: '100%', maxWidth: '400px', position: 'relative', zIndex: 1 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{
            background: 'var(--white)', borderRadius: '8px',
            padding: '22px 26px', marginBottom: '20px'
          }}>
            <img src={logo} alt="Tranzparts Group Limited" style={{ width: '100%', maxWidth: '300px', objectFit: 'contain', display: 'block', margin: '0 auto' }} />
          </div>
          <div style={{ color: 'var(--red)', fontSize: '11px', fontWeight: '500', letterSpacing: '2px', textTransform: 'uppercase' }}>
            Staff Portal
          </div>
        </div>

        {/* Card */}
        <div style={{
          background: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(255,255,255,0.15)',
          borderTop: '3px solid var(--red)',
          borderRadius: '8px',
          padding: '36px'
        }}>
          <h2 style={{ color: 'var(--white)', fontSize: '22px', fontWeight: '700', marginBottom: '28px', textAlign: 'center' }}>
            Sign In
          </h2>

          {error && (
            <div style={{ background: 'rgba(237,28,36,0.15)', border: '1px solid rgba(237,28,36,0.35)', color: '#ff9b9f', padding: '12px 16px', borderRadius: '4px', fontSize: '13px', marginBottom: '20px' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label style={{ display: 'block', fontSize: '10px', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.6)', fontWeight: '500', marginBottom: '8px' }}>
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                style={{
                  width: '100%', padding: '12px 14px',
                  background: 'rgba(255,255,255,0.06)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  borderRadius: '4px', color: 'var(--white)',
                  fontFamily: 'Inter, sans-serif', fontSize: '14px'
                }}
              />
            </div>

            <div className="form-group">
              <label style={{ display: 'block', fontSize: '10px', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.6)', fontWeight: '500', marginBottom: '8px' }}>
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                style={{
                  width: '100%', padding: '12px 14px',
                  background: 'rgba(255,255,255,0.06)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  borderRadius: '4px', color: 'var(--white)',
                  fontFamily: 'Inter, sans-serif', fontSize: '14px'
                }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%', padding: '13px',
                background: 'var(--red)', color: 'var(--white)',
                border: 'none', borderRadius: '4px',
                fontFamily: 'Inter, sans-serif', fontSize: '12px',
                fontWeight: '700', letterSpacing: '2px',
                textTransform: 'uppercase', cursor: 'pointer',
                marginTop: '8px', opacity: loading ? 0.7 : 1,
                transition: 'all 0.2s'
              }}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.4)', fontSize: '12px', marginTop: '20px', marginBottom: 0 }}>
            Forgotten your password? Ask your administrator to reset it.
          </p>
        </div>

        <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.25)', fontSize: '11px', marginTop: '24px', letterSpacing: '0.5px' }}>
          Tranzparts Group Ltd
        </p>
      </div>
    </div>
  );
};

export default Login;
